import "./DeleteAssignmentConfirmationModal.styles.scss";
import React from "react";
import { useTranslation } from "react-i18next";
import { Icon, Button } from "components";
import WarningIcon from "assets/icons/exclamation-triangle.svg";
import useAssignmentLibraryUtils from "../../useAssignmentLibraryUtils";
import {
  useOrganizationSettings,
  getPatientWordPlural,
} from "utils/hooks/organizations/useOrganizationSettings";

interface DeleteAssignmentConfirmationModalProps {
  onCancel: () => void;
  assignment: any;
}

const DeleteAssignmentConfirmationModal = ({
  assignment,
  onCancel,
}: DeleteAssignmentConfirmationModalProps) => {
  const { handleDeleteAssignmentTemplate } = useAssignmentLibraryUtils();
  const { t } = useTranslation(["common"]);
  const { settings } = useOrganizationSettings();

  return (
    <div className="assignment-deletion-confirmation">
      <div className="assignment-deletion-confirmation__icon">
        <Icon src={WarningIcon} />
      </div>
      <div className="assignment-deletion-confirmation__title">
        Are you sure you want to delete this assignment from your library?
      </div>
      <div className="assignment-deletion-confirmation__body">
        {t("resources.therapist_assignment_delete_warn", {
          patientWordPlural: getPatientWordPlural(settings),
        })}
      </div>
      <div className="assignment-deletion-confirmation__buttons">
        <Button
          onClick={onCancel}
          name={`cancel_delete_resource_button`}
          value="Never mind"
          extraClass="secondary-bland"
          size="small"
        />
        <Button
          onClick={() => {
            handleDeleteAssignmentTemplate(assignment);
            onCancel();
          }}
          name={`confirm_delete_resource_button`}
          value="Yes, delete it"
          extraClass="danger"
          size="small"
        />
      </div>
    </div>
  );
};

export default DeleteAssignmentConfirmationModal;
